import React from 'react';

import {
    // AppAsideToggler,
    CHeaderBrand, CContainer, CHeaderNav,
    // AppSidebarToggler
} from '@coreui/react';
import { Nav } from 'reactstrap';

import HeaderUserController from '../../../../features/auth/HeaderUserController';
import StoreLanguageDropdown from '../../../../features/storeLocale/StoreLanguageDropdown';
import EndOfSessionWarner from '../../../../features/sessionTimeout/EndOfSessionWarner';
import HeaderNotificationsController from '../../../../features/notifications/HeaderNotificationsController';
import Toast from '../../../Toast';

import logo from '../../../../assets/logo/connectico-logo.png';
import logoFull from '../../../../assets/logo/connectico-logo-full.png';
import ShopRedirectButton from '../../../ShopRedirectButton';
import ErpSyncButton from '../../../ErpSyncButton';
import RefreshButton from './RefreshButton';
import LastSyncDate from '../../../../features/global/LastSyncDate';

/**
 * @param {{ onLeftToggler: () => void, onRightToggler: () => void }} param0
 */
function DefaultHeader({ onLeftToggler, onRightToggler })
{
    return (
        <CContainer fluid className="d-flex justify-content-between align-items-center">
            {/* <AppSidebarToggler className="d-lg-none" display="md" mobile/> */}
            {/* <CHeaderBrand size={}
                full={{ src: logoFull, width: 140, alt: 'Connectico Logo' }}
                minimized={{ src: logo, width: 100, alt: 'Connectico Logo' }}
            /> */}
            <CHeaderBrand className="d-md-none mx-1" to="/">
                <img src={logo} width={100} alt="Connectico Logo" />
            </CHeaderBrand>
            <CHeaderBrand className="d-none d-md-flex mx-2" to="/">
                <img src={logoFull} width={140} alt="Connectico Logo" />
            </CHeaderBrand>
            {/* <AppSidebarToggler className="d-md-down-none" display="lg" /> */}
            <button className="navbar-toggler sidebar-toggler d-md-down-none" type="button" data-toggle="sidebar-show" onClick={onLeftToggler}>
                <i className="fas fa-bars" />
            </button>
            <Nav className="d-md-down-none" navbar>

            </Nav>
            {/* <Nav className="ml-auto d-flex align-items-end" navbar> */}
            <CHeaderNav className="d-none ml-auto d-md-flex align-items-center">
                <Toast />
                <EndOfSessionWarner />
                <RefreshButton />
                <LastSyncDate className='d-none d-xl-flex' />
                <HeaderNotificationsController />
                <ErpSyncButton className="d-none d-lg-flex ml-2" />
                <ShopRedirectButton className="d-none d-lg-block mx-2" />
                <StoreLanguageDropdown  className="d-none d-lg-block" />
                <HeaderUserController />
            </CHeaderNav>
            {/* </Nav> */}
            {/* <AppAsideToggler className="d-md-down-none" />
            <AppAsideToggler className="d-lg-none" mobile /> */}
            <button className="navbar-toggler sidebar-toggler d-md-down-none" type="button" onClick={() => onRightToggler()}>
                <i className="fas fa-bars" />
            </button>
        </CContainer>
    );
}

export default DefaultHeader;